module.exports = __webpack_public_path__ + "static/pain-body-muscles-stiff-problem-suffer-c024b18d9b05efdd23d97a8c513e507b.webp";